import React, { FC } from 'react'
import styled from 'styled-components'
import { Text } from '../../../redesign/text/textStyles'

const Container = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 8px;
`

const Summary = styled(Text)`
    display: flex;
`

const ProgressTrack = styled.div`
    width: 200px;
    height: 10px;
    border-radius: 8px;
    background-color: #e3e3e3;
    position: relative;
`

const Progress = styled.div<{ $value: string }>`
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: ${(p) => p.$value};
    border-radius: 8px;
    background-color: #880a47;
`

// Shared-package component: it takes the counts as props instead of reading the app's
// Redux store, so the package builds on its own (Storybook could not resolve the app-only
// 'app/store/selectors' alias). Missing counts show as 0, as before.
interface Props {
    monthlyConsultLimit?: number | null
    consultsUsedThisMonth?: number | null
}

export const FreeConsults: FC<Props> = ({
    monthlyConsultLimit,
    consultsUsedThisMonth,
}) => {
    const totalFreeConsults = monthlyConsultLimit ?? 0
    const usedConsults = consultsUsedThisMonth ?? 0

    const renewalMessage = () => {
        const now = new Date()
        const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1) // 1st of next month
        nextMonth.setHours(0, 0, 0, 0) // Set to 12:00 AM

        const options: Intl.DateTimeFormatOptions = {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        }

        return 'Renews ' + nextMonth.toLocaleString('en-US', options)
    }

    return (
        <Container>
            <Summary size="medium" $weight="regular">
                <Text size="medium" $weight="bold">
                    {usedConsults}
                </Text>{' '}
                &nbsp;out of {totalFreeConsults}
            </Summary>
            <ProgressTrack>
                <Progress
                    $value={`${Math.floor((usedConsults / totalFreeConsults) * 200)}px`}
                />
            </ProgressTrack>
            <Text size="small" $weight="regular" color="secondary">
                {renewalMessage()}
            </Text>
        </Container>
    )
}
